function Home() {

    const applicationName = "Agrolend SAI";
    const version = "Versao: 1";


    return (
        <div className="h-full p-3">
            <h1 className="text-2xl">{applicationName}</h1>
            <span className="text-sm">{version}</span>
            {/* <FloatingActionButton
                hint="Add"
                icon={BiHelpCircle}
                color="violet"
                onClick={() => {
                    window.alert(`${applicationName} ${version}`);
            }} /> */}

            {/* <MultiFloatingButton
                mainButtonColor="red"
                mainButtonIcon={BiAddToQueue}
                mainButtonHint="Main Button Hint"
                actionButtons={actionButtons}
            /> */}

        </div>
    );
}

export default Home;